/** Icons supplied for the navigation actions, shared by desktop and mobile. */
export function NavigationSearchIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[18px]! w-[18px]!"
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1667 11.1667L16.5 16.5M6.72222 12.9444C3.28578 12.9444 0.5 10.1587 0.5 6.72222C0.5 3.28578 3.28578 0.5 6.72222 0.5C10.1587 0.5 12.9444 3.28578 12.9444 6.72222C12.9444 10.1587 10.1587 12.9444 6.72222 12.9444Z"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavigationWishlistIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[15px]! w-[18px]!"
      fill="none"
      height="15"
      viewBox="0 0 18 15"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0752 1.26562C12.2848 0.428843 13.8961 0.254114 15.1953 0.861328C16.4975 1.47033 17.4551 2.88864 17.498 4.38477C17.5396 5.83988 16.7944 7.23435 15.876 8.52344C14.5423 10.3957 11.8723 12.8745 9 14.4307C6.12775 12.8745 3.4577 10.3956 2.12402 8.52344C1.20561 7.2344 0.46041 5.83993 0.501953 4.38477C0.544626 2.88865 1.50253 1.47031 2.80469 0.861328C4.10417 0.254079 5.71546 0.428893 6.9248 1.26562C7.61028 1.7401 8.16866 2.4176 8.55078 3.20312L9 4.12695L9.4502 3.20312C9.83209 2.41756 10.3897 1.74007 11.0752 1.26562Z"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </svg>
  );
}

export function NavigationCartIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[17px]! w-[19px]!"
      fill="none"
      height="17"
      viewBox="0 0 19 17"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.90893 13.4657H16.2512M5.07577 4.47569C5.07577 2.27998 6.79835 0.5 8.92325 0.5C11.0482 0.5 12.7707 2.27998 12.7707 4.47569M13.6467 16.5H4.51344C3.2734 16.5 2.21915 15.5644 2.03192 14.2977L0.580078 4.47569H17.5801L16.1282 14.2977C15.941 15.5644 14.8868 16.5 13.6467 16.5Z"
        stroke="currentColor"
        strokeLinecap="square"
      />
    </svg>
  );
}

export function NavigationProfileIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[18px]! w-[18px]!"
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5098 17.5C16.4042 12.3207 12.8671 8.15859 8.50977 8.15859C4.15247 8.15859 0.615313 12.3207 0.509766 17.5M12.0131 4.29151C12.0131 6.3855 10.3516 8.08301 8.30214 8.08301C6.25266 8.08301 4.59122 6.3855 4.59122 4.29151C4.59122 2.19751 6.25266 0.5 8.30214 0.5C10.3516 0.5 12.0131 2.19751 12.0131 4.29151Z"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Marks the suggested location in the country bar's select. */
export function NavigationCheckIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[12px]! w-[15.2866px]! shrink-0"
      fill="none"
      height="12"
      viewBox="0 0 15.2866 12"
      width="15.2866"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9326 1.80859L5.0957 11.6465L0.353516 6.90527L1.79688 5.46191L4.89746 8.5498C4.94411 8.60903 5.01592 8.64551 5.09375 8.64551H5.09668C5.16353 8.64548 5.22369 8.61635 5.26953 8.57129L5.27051 8.57227L5.27832 8.56445C5.28226 8.56022 5.28639 8.55627 5.29004 8.55176L13.4883 0.353516L14.9326 1.80859Z"
        fill="black"
        stroke="white"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
    </svg>
  );
}

/** Points left as drawn; the country bar rotates it to point down. */
export function NavigationChevronIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[13.6201px]! w-[7.44626px]!"
      fill="none"
      height="13.6201"
      viewBox="0 0 7.44626 13.6201"
      width="7.44626"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6.53774 0.362822C6.68817 0.212393 6.93301 0.212393 7.08343 0.362822C7.23386 0.513252 7.23386 0.758087 7.08343 0.908516L1.18188 6.81007L7.08343 12.7116C7.23386 12.862 7.23386 13.1069 7.08343 13.2573C6.93301 13.4077 6.68817 13.4077 6.53774 13.2573L0.362822 7.0824C0.212393 6.93136 0.212393 6.68713 0.362822 6.5367L6.53774 0.361783V0.362822Z"
        fill="black"
        fillRule="evenodd"
        stroke="black"
        strokeLinejoin="bevel"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function NavigationCloseIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-[20px]! w-[20px]!"
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6319 15.6773L15.6773 16.6319L3.26759 4.22219L4.22218 3.26759L16.6319 15.6773Z"
        fill="white"
      />
      <path
        d="M4.22219 16.6319L3.26759 15.6773L15.6773 3.26759L16.6319 4.22219L4.22219 16.6319Z"
        fill="white"
      />
    </svg>
  );
}
